import React from "react";
import * as Glob from "../../Globale";
import { AnalyserWrapper, LoanFormPensioners, PageWrapper } from "../../components";
import { Nav } from "../../components/DigitalProductAnalyser/Constants";
import "../../components/DigitalProductAnalyser/style.css";

export const PensionersAnalyser: React.FC<Glob.IRouteGlobaleProps> = props => {
    const session = (props.match.params as any).Sessione;

    return (
        <div className="page_dpa kt-wrapper" id="kt_wrapper">
            <PageWrapper Session={session}>
                <AnalyserWrapper NavItems={Nav["Pensioners"]} Session={session}>
                    <div className="tab-pane active" id="loan_form" role="tabpanel">
                        <LoanFormPensioners />
                    </div>
                </AnalyserWrapper>
            </PageWrapper>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/form/DigitalProductAnalyser/PensionersAnalyser.tsx